export default {"src":"/_next/static/media/facebook.899e2107.svg","height":40,"width":40};